import React, { ComponentType, FC, createContext } from 'react';

import { PublicUserProfile } from 'api';
import { Queries } from 'components';
import { useCurrentUser } from 'hooks';
import { FOLLOW_QUERIES_LIMIT } from 'constants/index';

export interface IWithFollowers {
  followers: PublicUserProfile[];
}

const FollowersContext = createContext<IWithFollowers>({
  followers: [],
});

const FollowersProvider: FC = ({ children }) => {
  const currentUser = useCurrentUser();
  const variables = { user_id: currentUser.id, limit: FOLLOW_QUERIES_LIMIT };

  return (
    <Queries.GetFollowers variables={variables}>
      {({ followers }) => (
        <FollowersContext.Provider value={{ followers }}>{children}</FollowersContext.Provider>
      )}
    </Queries.GetFollowers>
  );
};

const withFollowers = () => <T extends IWithFollowers>(ChildComponent: ComponentType<T>) => (
  props: T,
) => (
  <FollowersContext.Consumer>
    {followers => <ChildComponent {...(props as T)} followers={followers} />}
  </FollowersContext.Consumer>
);

export { withFollowers, FollowersContext, FollowersProvider };
